function hideProductModal() {
  const productModal = document.querySelectorAll('product-modal[open]');
  productModal && productModal.forEach((modal) => modal.hide());
}


document.addEventListener('shopify:block:select', function (event) {
  hideProductModal();
  const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockSelectedIsSlide) return;

  const parentSlideshowComponent = event.target.closest('slideshow-component');
  parentSlideshowComponent.pause();

  setTimeout(function () {
    parentSlideshowComponent.slider.scrollTo({
      left: event.target.offsetLeft,
    });
  }, 200);
});

document.addEventListener('shopify:block:deselect', function (event) {
  const blockDeselectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockDeselectedIsSlide) return;
  const parentSlideshowComponent = event.target.closest('slideshow-component');
  if (parentSlideshowComponent.autoplayButtonIsSetToPlay) parentSlideshowComponent.play();
});

document.addEventListener('shopify:section:load', () => {
  hideProductModal();
  const zoomOnHoverScript = document.querySelector('[id^=EnableZoomOnHover]');
  if (!zoomOnHoverScript) return;
  if (zoomOnHoverScript) {
    const newScriptTag = document.createElement('script');
    newScriptTag.src = zoomOnHoverScript.src;
    zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript);
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  document.querySelectorAll(`[data-section="${event.detail.sectionId}"]`).forEach((element) => {
    element.remove();
    document.body.classList.remove('overflow-hidden');
  });
});

document.addEventListener('shopify:section:reorder', () => hideProductModal());

document.addEventListener('shopify:section:select', () => hideProductModal());

document.addEventListener('shopify:section:deselect', () => hideProductModal());

document.addEventListener('shopify:inspector:activate', () => hideProductModal());

document.addEventListener('shopify:inspector:deactivate', () => hideProductModal());
document.addEventListener("DOMContentLoaded", function () {
    // Select the last thumbnail
    const lastThumbnail = document.querySelector(
        "#Slider-Thumbnails-template--17830966034618__main > li:last-child"
    );

    // Check if the thumbnail exists
    if (lastThumbnail) {
        // Hide the thumbnail and ensure no pointer events or visibility
        lastThumbnail.style.display = "none";
        lastThumbnail.style.visibility = "hidden";
        lastThumbnail.style.pointerEvents = "none";
        lastThumbnail.style.height = "0";
        lastThumbnail.style.width = "0";
        lastThumbnail.style.overflow = "hidden";

        // Ensure changes apply when the window is resized
        window.addEventListener("resize", function () {
            if (lastThumbnail.style.display !== "none") {
                lastThumbnail.style.display = "none";
                lastThumbnail.style.visibility = "hidden";
                lastThumbnail.style.pointerEvents = "none";
                lastThumbnail.style.height = "0";
                lastThumbnail.style.width = "0";
                lastThumbnail.style.overflow = "hidden";
            }
        });
    }
});
document.addEventListener("DOMContentLoaded", function () {
    const lastThumbnail = document.querySelector("#Slider-Thumbnails-template--17830966034618__main > li:last-child");
    if (lastThumbnail) {
        lastThumbnail.style.display = "none";
    }
});
document.addEventListener('DOMContentLoaded', function () {
  // Select all product images in the product gallery
  const productImages = document.querySelectorAll('.product-single__media-item');
  
  // Check if there are images and hide the last one
  if (productImages.length > 0) {
    const lastImage = productImages[productImages.length - 1];
    
    // Hide the last image
    lastImage.style.display = 'none';
  }
});

document.addEventListener('DOMContentLoaded', initializeVariantMenu);
document.addEventListener('shopify:section:load', initializeVariantMenu);

function initializeVariantMenu() {
  const variantButton = document.getElementById('variant-selector-button');
  const sideMenu = document.getElementById('variant-side-menu');
  const buyButtonContainer = document.getElementById('buy-button-container');
  const cartCloseButton = document.getElementById('cart-close-button'); // Ensure you have a cart close button
  const cart = document.getElementById('cart'); // Assuming the cart has an ID 'cart'

  // Ensure required elements exist
  if (!variantButton || !sideMenu || !buyButtonContainer) {
    console.error('Required elements are missing in the DOM.');
    return;
  }

  // Open the side menu
  variantButton.addEventListener('click', () => {
    sideMenu.classList.add('open');
  });

  // Close the side menu
  window.closeVariantMenu = function () {
    sideMenu.classList.remove('open');
    
  };

  // Handle variant selection
  const variantInputs = document.querySelectorAll('input[name="selected-variant"]');
  variantInputs.forEach(input => {
    input.addEventListener('change', function () {
      const selectedVariantId = this.value;

      // Update the buy button form's variant ID
      const buyButtonForm = buyButtonContainer.querySelector('form');
      if (buyButtonForm) {
        const variantInputField = buyButtonForm.querySelector('input[name="id"]');
        if (variantInputField) {
          variantInputField.value = selectedVariantId;
        }
      }
    });
  });

  // Ensure the side menu closes when "Add to Cart" is clicked
  const addToCartButtons = buyButtonContainer.querySelectorAll('.add-to-cart');
  addToCartButtons.forEach(button => {
    button.addEventListener('click', () => {
      closeVariantMenu();
    });
  });

  // Handle form submission directly (if triggered by Shopify's "buy-buttons")
  const buyButtonForm = buyButtonContainer.querySelector('form');
  if (buyButtonForm) {
    buyButtonForm.addEventListener('submit', (event) => {
      closeVariantMenu();
      
      // Prevent default action if needed (optional, depending on Shopify behavior)
      event.preventDefault();
    });
  }

  // Close the variant side menu when the cart is closed
  if (cartCloseButton) {
    cartCloseButton.addEventListener('click', () => {
      closeVariantMenu(); // Close the variant menu when the cart is closed
      cart.style.display = 'none'; // Close the cart (example action)
    });
  }

  // Add global click listener to check for unintended menu reopening
  document.addEventListener('click', (event) => {
    if (!sideMenu.contains(event.target) && !variantButton.contains(event.target)) {
      closeVariantMenu();
    }
  });

  // Debugging (Optional): Log the current state of the side menu
  console.log('Variant menu initialized.');
}
